import React from 'react';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

// Import login page
import Header from "../components/Header";
import Login from '../components/logon';
import Menu from '../components/MainMenu';
import NewOrder from '../components/NewOrder';
import NotFoundPage from '../components/NotFoundPage';
import ProtectedRoute from './ProtectedRoute';
import Unauthorized from '../components/Unauthorized';
import SunshineMarketPlace from '../components/SunshineMarketPlace.js';
import Contacts from '../components/Contacts';
import S1PhoneDirectory from '../components/S1PhoneDirectory';


const AppRouter = () => {
    const location = useLocation();
    const hideHeaderRoutes =['/', '/login','/detrack','/marketplace', '/contacts', '/s1-phone-directory'];

    return (
     <>
       {!hideHeaderRoutes.includes(location.pathname) && <Header />}
        <Routes>
            <Route path="/" element={<Login />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="/marketplace" element={<SunshineMarketPlace />}/>
            <Route path="/contacts" element={<Contacts />}/>
            <Route path="/s1-phone-directory" element={<S1PhoneDirectory />}/>
            <Route path="/menu" element={<ProtectedRoute><Menu /></ProtectedRoute>}/>
            <Route path="/neworder" element={<ProtectedRoute><NewOrder /></ProtectedRoute>}/>
            <Route path="/unauthorized" element={<Unauthorized />}/>
            <Route path="*" element={<NotFoundPage />}/>
        </Routes>
    </>
    )
};

const App = () => (
    <BrowserRouter>
        <AppRouter />
    </BrowserRouter>
)

export default App;


